// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-backdrop {
  &:not(.fullscreen) {
    .panel {
      height: 100%;
    }
  }

  .panel {
    display: flex;
    flex-direction: column;

    box-sizing: border-box;
    border: 1px solid var(--color-border);
    border-radius: 7px;

    min-width: var(--panel-min-width);
    max-width: var(--panel-max-width);

    margin: 0 auto;

    max-height: 100%;

    * {
      text-align: center;
    }

    & > * {
      width: 100%;
    }

    & > .header {
      display: flex;
      flex-direction: row;
      padding: 0.75em;

      border-radius: 7px;

      &.default {
        background-color: var(--color-background-header);
      }

      & > * {
        flex-grow: 1;
      }

      img {
        height: 1.5em;
      }

      #triangle {
        width: 2em;
        flex-grow: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        transition-property: transform;
        transition-duration: 0.25s;

        &.opened {
          transform: rotate(0.25turn);
        }
      }

      #custom {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        & > .first * {
          padding-right: 1em;
        }
      }
    }

    & > .body {
      display: flex;
      flex-direction: column;
      height: 100%;

      /* vertical horizontal */
      padding: 0.75rem 1.25rem;

      & > * {
        width: 100%;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/widget/panel.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;;IAEtB,sBAAsB;IACtB,qCAAqC;IACrC,kBAAkB;;IAElB,iCAAiC;IACjC,iCAAiC;;IAEjC,cAAc;;IAEd,gBAAgB;;IAEhB;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;;MAEf,kBAAkB;;MAElB;QACE,gDAAgD;MAClD;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,UAAU;QACV,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB,8BAA8B;QAC9B,0BAA0B;;QAE1B;UACE,2BAA2B;QAC7B;MACF;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,8BAA8B;;QAE9B;UACE,kBAAkB;QACpB;MACF;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;;MAEZ,wBAAwB;MACxB,wBAAwB;;MAExB;QACE,WAAW;MACb;IACF;EACF;AACF","sourcesContent":[".panel-backdrop {\n  &:not(.fullscreen) {\n    .panel {\n      height: 100%;\n    }\n  }\n\n  .panel {\n    display: flex;\n    flex-direction: column;\n\n    box-sizing: border-box;\n    border: 1px solid var(--color-border);\n    border-radius: 7px;\n\n    min-width: var(--panel-min-width);\n    max-width: var(--panel-max-width);\n\n    margin: 0 auto;\n\n    max-height: 100%;\n\n    * {\n      text-align: center;\n    }\n\n    & > * {\n      width: 100%;\n    }\n\n    & > .header {\n      display: flex;\n      flex-direction: row;\n      padding: 0.75em;\n\n      border-radius: 7px;\n\n      &.default {\n        background-color: var(--color-background-header);\n      }\n\n      & > * {\n        flex-grow: 1;\n      }\n\n      img {\n        height: 1.5em;\n      }\n\n      #triangle {\n        width: 2em;\n        flex-grow: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        transition-property: transform;\n        transition-duration: 0.25s;\n\n        &.opened {\n          transform: rotate(0.25turn);\n        }\n      }\n\n      #custom {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n\n        & > .first * {\n          padding-right: 1em;\n        }\n      }\n    }\n\n    & > .body {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n\n      /* vertical horizontal */\n      padding: 0.75rem 1.25rem;\n\n      & > * {\n        width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
